module.exports = __webpack_public_path__ + "static/img/ziyuan_01.c80771f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ziyuan_01.png
// module id = DRXa
// module chunks = 0